import { Button, ScalableImage, Typography, useDevice } from "design_system/src";
import { ReactComponent as GPS } from "design_system/src/static/icons/gps.svg";
import React, { useEffect, useMemo, useState } from "react";


export interface HeadquarterItemProps {
  title: string;
  subtitle: string;
  address: string;
  googleMapsLink: string;
  imageUrl: string;
  desktopImageUrl: string;
  dekstopLineUrl: string;
  imageAlt: string;
}

const HeadquarterItem: React.FC<HeadquarterItemProps> = ({
  title,
  subtitle,
  address,
  googleMapsLink,
  imageUrl,
  desktopImageUrl,
  dekstopLineUrl,
  imageAlt,
}) => {
  const { isMobile: isDeviceMobile, isLoading } = useDevice();
  const [isMobile, setIsMobile] = useState<boolean>();
  const [imgUrl, setImgUrl] = useState<string>();
  const [imgLineUrl, setImgLineUrl] = useState<string>();
  const containerClassname = useMemo(
    () =>
      isMobile
        ? "p_t_xl p_b_lg p_x_lg"
        : "p_y_xxxl p_x_xxl",
    [isMobile]
  );
  const contentClassname = useMemo(
    () =>
      isMobile
        ? "w_100_per"
        : "w_50_per",
    [isMobile]
  );
  const buttonContainerClassname = useMemo(
    () =>
      isMobile
        ? "w_100_per"
        : "w_60_per",
    [isMobile]
  );

  useEffect(() => {
    if (!isLoading) {
      setIsMobile(isDeviceMobile);
    }

  }, [isDeviceMobile, isLoading]);

  useEffect(() => {
    if (isMobile !== undefined) {
      setImgUrl(isMobile ? imageUrl : desktopImageUrl);
      setImgLineUrl(isMobile ? undefined : dekstopLineUrl);
    }

  }, [isMobile]);

  return (
    <div className={`display_flex flex_col_mobile flex_justify_between h_100_per pos_relative ${containerClassname}`}>
      {/* text */}
      <div className={`display_flex flex_col flex_justify_between m_b_xxl m_r_lg_desktop ${contentClassname}`}>
        <Typography
          weight="600"
          scale="heading3"
          scaleMobile="large"
          className="text_primary_300 m_b_md"
        >
          {title} <br />
          <Typography
            weight="400"
            scale="heading3"
            scaleMobile="large"
            className="text_primary_300"
            component="span"
          >
            {subtitle}
          </Typography>
        </Typography>

        <div className="display_flex m_b_md">
          <div className="m_r_sm">
            <GPS className="w_xl h_xl text_primary_300" />
          </div>
          <Typography
            weight="400"
            scale="large"
            scaleMobile="medium"
          >
            {address}
          </Typography>
        </div>

        <div className={buttonContainerClassname}>
          <a href={googleMapsLink} target="_blank" rel="noreferrer">
            <Button scale="small" className="w_100_per">
              <Typography
                weight="600"
                scale="medium"
                scaleMobile="medium"
              >
                Ir a Google Maps
              </Typography>
            </Button>
          </a>
        </div>
      </div>

      {/* image */}
      <div className={contentClassname}>
        <ScalableImage
          className="img_contain"
          src={imgUrl}
          alt={imageAlt}
        />
      </div>

      {/* line image */}
      {imgLineUrl && (
        <div
          className="pos_absolute h_100_per"
          style={{
            top: 0,
            right: 0,
          }}
        >
          <ScalableImage
            className="img_contain"
            src={imgLineUrl}
            alt=""
          />
        </div>
      )}
    </div>
  );
};

export default HeadquarterItem;
